import React, { Component } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

import './Loading.css';

class Loads extends Component {
    
  render() {
    
    return (
        <div width="100%" className="image-loader" hidden={ this.props.hidden }>
          <LinearProgress  />
        </div>
      );
  }
}

export default Loads;
